export default {
  "content": "<g clip-path=\"url(#icon_stop_outlined_svg__a)\"><path d=\"M13.99 2.71a3.8 3.8 0 00-.33-.37 3.8 3.8 0 00-.37-.33A7.945 7.945 0 008 0C3.58 0 0 3.58 0 8c0 2.03.76 3.88 2.01 5.29.1.13.21.25.33.37l.37.33A7.945 7.945 0 008 16c4.42 0 8-3.58 8-8 0-2.03-.76-3.88-2.01-5.29zM1 8c0-3.86 3.14-7 7-7 1.68 0 3.31.6 4.58 1.72l-9.86 9.86A6.913 6.913 0 011 8zm7 7c-1.68 0-3.31-.6-4.58-1.72l9.86-9.86A6.913 6.913 0 0115 8c0 3.86-3.14 7-7 7z\"/></g><defs><clipPath id=\"icon_stop_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};